import BaseModel from '../core/BaseModel';
import UserModel from '@/models/UserModel';

export default class BannerModel extends BaseModel {
  constructor() {
    super(
      {
        name: 'banner',
        tableName: 'banner',
        label: 'Banner',
        // display_key: 'name',
      },
      {
        stt: {
          name: 'stt',
          label: 'No.',
          type: 'Computed',
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },

        id: {
          name: 'id',
          type: 'Uuid',
          label: 'ID',
          primaryKey: true,
          display: false,
        },

        avatar: {
          name: 'avatar',
          label: 'Image',
          custom: 'image',
          type: 'Computed',
          computed: (data, index) => {
            data.avatar = index + 1;
          },
          width: 3,
          class: 'left',
        },

        name: {
          name: 'name',
          type: 'String',
          label: 'Title',
          filter: { type: 'input', match: 'contains' },
          class: 'left',
        },
        link: {
          name: 'link',
          type: 'String',
          label: 'Link',
          //filter: { type: 'input', match: 'contains' },
          class: 'left',
        },

        active: {
          name: 'active',
          label: 'Active',
          type: 'Selection',
          custom: 'SelectionText',
          options: [
            { value: 'true', label: 'Yes', style: 'color:  #000000;' },
            { value: 'false', label: 'No', style: 'color:  #000000;' },
          ],
          filter: {
            type: 'select',
            optionLabel: 'label',
            optionKey: 'value',
            match: 'equals',
          },
          class: 'active-css',
          width: 8,
        },

        updated_by: {
          name: 'updated_by',
          type: 'Uuid',
          label: 'Updated By',
          display: false,
        },

        updated_by_key: {
          name: 'updated_by_key',
          label: 'Updated by',
          type: 'Computed',
          models: new UserModel(),
          computed: (data) => {
            data.updated_by_key = '';
          },
          class: 'left',
          width: 10,
        },

        updated_at: {
          name: 'updated_at',
          type: 'String',
          label: 'Updated date',
          width: 10,
          class: 'left',
        },

        created_at: {
          name: 'created_at',
          type: 'Datetime',
          label: 'Created At',
          display: false,
        },

        created_by: {
          name: 'created_by',
          type: 'Uuid',
          label: 'Created By',
          display: false,
        },

        deleted: {
          name: 'deleted',
          type: 'Boolean',
          label: 'Deleted',
          display: false,
        },
        detail_get: {
          refs:  ' alt  ',
          display: false
      },
      }
    );
  }
}
